import { useDispatch } from 'react-redux';
import { bindActionCreators } from '@reduxjs/toolkit';
import { push } from 'connected-react-router';

export const useRouterPush = (): typeof push => {
  const dispatch = useDispatch();

  return bindActionCreators(push, dispatch);
};
